const DATA = [
  {
    id: 83,
    title: "The Future of AI: AI's 10 To Watch",
    link:
      'https://www.computer.org/csdl/magazine/ex/2020/06/09309122/1pQErWJSbpC',
    author: 'IEEE Intelligent Systems',
  },
  {
    id: 85,
    title: 'Coders Worldwide Help Computers Understand Natural Language',
    link:
      'https://medium.com/swlh/coders-worldwide-help-computers-understand-natural-language-52358db1143a',
    author: 'Medium',
  },
  {
    id: 86,
    title: 'Bringing Command Line AI to z/OS Unix System Services',
    link:
      'https://community.ibm.com/community/user/ibmz-and-linuxone/blogs/dan-fitzgerald1/2020/10/30/bringing-command-line-ai-to-zos-uss',
    author: 'IBM Z and LinuxONE Community',
  },
  {
    id: 87,
    title: 'Researchers Publish Survey of Explainable AI',
    link: 'https://www.infoq.com/news/2020/03/explainable-ai-survey/',
    author: 'InfoQ',
  },
  {
    id: 88,
    title: 'Bringing AI to the Command Line',
    link:
      'https://www.ibm.com/blogs/research/2020/02/bringing-ai-to-the-command-line/',
    author: 'IBM Research',
  },
  {
    id: 89,
    title:
      'IBM announces "CLAI" project that incorporates AI into the command line!',
    link: 'https://techable.jp/archives/117139',
    author: 'Techable',
  },
  {
    id: 90,
    title: 'IBM injects AI into the command line',
    link:
      'https://jack-clark.net/2020/02/10/import-ai-184-ibm-injects-ai-into-the-command-line-facebook-releases-4-5-billion-parallel-sentences-to-aid-translation-research-plus-vr-prison/',
    author: 'Import AI',
  },
  {
    id: 91,
    title: 'Automated Planning Research @ AAAI 2020',
    link:
      'https://www.ibm.com/blogs/research/2020/02/automated-planning-aaai-2020/',
    author: 'IBM Research',
  },
  {
    id: 84,
    title: 'A Unifying Framework for Expectation-Aware AI Planning',
    link:
      'https://mitibmwatsonailab.mit.edu/research/blog/expectation-aware-planning-a-unifying-framework-for-synthesizing-and-executing-self-explaining-plans-for-human-aware-planning/',
    author: 'MIT-IBM Lab',
  },
  {
    id: 92,
    title: 'When is it OK for AI to lie? ',
    link: 'https://asunow.asu.edu/20190130-when-it-ok-ai-lie',
    author: 'ASU Now',
  },
  {
    id: 93,
    title: 'AIES 2019 Highlights',
    link: 'https://www.acm.org/media-center/2019/january/aies-2019',
    author: 'ACM Tech News',
  },
  {
    id: 94,
    title: 'Should AI bots lie? Hard truths about artificial intelligence',
    link: 'https://www.zdnet.com/article/should-ai-bots-lie/',
    author: 'ZDNet',
  },
  {
    id: 95,
    title: 'U.S. Finals of the 2017 Microsoft Imagine Cup',
    link: 'https://cronkitenews.azpbs.org/2017/04/26/april-26-2017-newscast/',
    author: 'PBS 8 Cronkite News',
  },
  {
    id: 96,
    title: 'ÆRobotics',
    link:
      'https://imaginecup.microsoft.com/en-us/Team/fa3eed61-a85d-43ab-b906-4353bd01c6f3',
    author: 'Microsoft Imagine Cup',
  },
  {
    id: 97,
    title: 'ASU Team Connects Humans, Robots Through Common Language',
    link:
      'https://technews.acm.org/archives.cfm?fo=2017-04-apr/apr-17-2017.html',
    author: 'ACM Tech News',
  },
  {
    id: 98,
    title:
      'ASU team taking concept for closer human-robot connection to U.S. Imagine Cup finals',
    link:
      'https://fullcircle.asu.edu/students/asu-team-taking-concept-closer-human-robot-connection-u-s-imagine-cup-finals/',
    author: 'ASU Now',
  },
  {
    id: 99,
    title: 'ASU team connects humans, robots through common language',
    link:
      'https://asunow.asu.edu/20170412-creativity-asu-team-connects-humans-robots-through-common-language',
    author: 'ASU Now',
  },
  {
    id: 100,
    title: 'Improving robot-human collaboration with the help of IBM',
    link:
      'https://fullcircle.asu.edu/research/improving-robot-human-collaboration-help-ibm/',
    author: 'Full Circle',
  },
];

export default DATA;
